<template>
    <div class="w-100 align-self-start">
        <v-card flat color="transparent">
            <v-card-title class="d-block">
                <v-btn class="mb-3" small text color="secondary" :to="{ name: 'user-pools' }">
                    <v-icon left>mdi-arrow-left</v-icon>
                    Resource Pools
                </v-btn>
                <div>Create account</div>
            </v-card-title>

            <v-card-text>
                <v-card flat style="max-width: 600px">
                    <v-card-text>
                        <v-form ref="form" v-model="formValid" @submit.prevent="submit">
                            <v-text-field
                                v-model="name"
                                label="Account name"
                                outlined
                                dense
                                :rules="[rules.required]"
                                :disabled="saving"
                                required></v-text-field>
                            <v-radio-group v-model="tenantMode" row :disabled="saving" class="mt-0">
                                <v-radio label="Create tenant" value="new"></v-radio>
                                <v-radio label="Use existing tenant" value="existing"></v-radio>
                            </v-radio-group>
                            <v-text-field
                                v-if="tenantMode === 'new'"
                                v-model="tenantName"
                                label="Tenant name"
                                outlined
                                dense
                                :rules="[rules.required]"
                                :disabled="saving"
                                required></v-text-field>
                            <v-select
                                v-else
                                v-model="tenantId"
                                :items="existingTenants"
                                item-text="long_id"
                                item-value="tntid"
                                label="Existing tenant"
                                outlined
                                dense
                                :rules="[rules.required]"
                                :loading="loadingTenants"
                                :disabled="saving || loadingTenants"
                                required></v-select>
                            <v-divider class="my-5"></v-divider>
                            <div class="text-subtitle-2 mb-2">Services</div>
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <v-checkbox v-model="services.hpc" label="HPC" dense hide-details :disabled="saving"></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-checkbox v-model="services.database" label="Database" dense hide-details :disabled="saving"></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-checkbox v-model="services.vimeo" label="Video library" dense hide-details :disabled="saving"></v-checkbox>
                                </v-col>
                            </v-row>
                            <div class="d-flex justify-end mt-6">
                                <v-btn :disabled="!formValid || saving" :loading="saving" color="primary" text type="submit">Create</v-btn>
                            </div>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'UserPoolsCreateAccount',
    data() {
        return {
            formValid: false,
            saving: false,
            loadingTenants: false,
            name: '',
            tenantMode: 'new',
            tenantName: '',
            tenantId: '',
            services: { hpc: false, database: false, vimeo: false },
            rules: {
                required: value => Boolean(String(value || '').trim()) || 'Field is required'
            }
        }
    },
    computed: {
        ...mapState('userStore', ['availableResourcePools']),
        existingTenants() {
            const tenantsById = new Map()
            this.availableResourcePools.forEach(pool => {
                if (!Number.isInteger(Number(pool.tntid))) return
                tenantsById.set(Number(pool.tntid), {
                    tntid: Number(pool.tntid),
                    long_id: pool.tenant_long_id || pool.tenant?.long_id || `Tenant ${pool.tntid}`
                })
            })
            return Array.from(tenantsById.values()).sort((left, right) => left.long_id.localeCompare(right.long_id))
        }
    },
    methods: {
        async fetchExistingTenants() {
            this.loadingTenants = true
            try {
                const { data } = await this.$axios.get('/resource/available_rps')
                this.$store.commit('userStore/setAvailableResourcePoolData', data)
            } finally {
                this.loadingTenants = false
            }
        },
        async submit() {
            if (!this.$refs.form || !this.$refs.form.validate()) {
                return
            }

            this.saving = true
            try {
                const payload = {
                    long_id: this.name.trim(),
                    resource_pool_type: 'ACCOUNT',
                    hpc_enabled: this.services.hpc,
                    db_enabled: this.services.database,
                    vimeo_enabled: this.services.vimeo
                }
                if (this.tenantMode === 'new') {
                    payload.tenant_long_id = this.tenantName.trim()
                } else {
                    payload.tntid = Number(this.tenantId)
                }
                await this.$axios.post('/resource_pools', payload)
                await this.$store.dispatch('userStore/fetchAvailableResourcePoolData')
                this.$store.dispatch('showSnackBar', {
                    snackBarText: 'Account created.',
                    snackBarTimeout: 5000,
                    snackBarIcon: 'check_circle'
                })
                this.$router.push({ name: 'user-pools' })
            } catch (error) {
                this.$store.dispatch('showSnackBar', {
                    snackBarText: error.response?.data?.debug || 'Could not create account.',
                    snackBarTimeout: 5000,
                    snackBarIcon: 'error'
                })
            } finally {
                this.saving = false
            }
        }
    },
    created() {
        this.fetchExistingTenants()
    }
}
</script>
